import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Access",
  "lead": "全球范围内，88% 的儿童完成了小学教育，78% 的青少年完成了初中教育，59% 的青年完成了高中教育。"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, Highlight, HighlightByIndex, IndicatorReference, PageLink, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!Highlight) _missingMdxReference("Highlight", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_ACCESS"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "全球未能实现到 2015 年让所有儿童上小学的承诺。新的教育目标，即 SDG 4，更加雄心勃勃，呼吁到 2030 年的最后期限所有年轻人都能完成中学教育。为了实现这一目标，所有达到入学年龄的儿童本应在 2018 年开始上学，但实际上，在低收入国家，只有 70％ 的儿童入学。"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "学前教育入学率",
      children: "学前教育入学率"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.2.2",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "接受学前教育"
        }), "是儿童教育之旅的关键起点。然而，在低收入国家，只有 44% 的儿童在上小学前一年接受了学前教育。"]
      })
    }), "\n", _jsx(_components.p, {
      children: "自 2000 年以来，在大多数国家，包括许多最贫穷国家，学龄前儿童入学率实现了缓慢但稳定的增长，但仍有许多国家落后。全球范围内，目前有 75％ 的儿童接受了学前教育，而在 2003 年，这一比例为 64％。"
    }), "\n", _jsx(_components.p, {
      children: "有些国家的增长幅度显著。例如，在吉尔吉斯斯坦，学前教育入学率从 2000 年的 42％ 提高到了 2024 年的 87％。同一时期，老挝人民民主共和国的学前教育入学率从 10％ 增长到 89％。"
    }), "\n", _jsxs(_components.p, {
      children: ["下面高亮显示的", _jsx(HighlightByIndex, {
        index: "0",
        children: "危地马拉"
      }), "和", _jsx(HighlightByIndex, {
        index: "1",
        children: "尼日尔"
      }), "都是学前教育入学率实现稳步增长的典型国家，尽管目前这两个国家之间存在巨大差距。选择您的国家查看其进展。"]
    }), "\n", _jsx(Figure, {
      id: "PREPRIM"
    }), "\n", _jsx(_components.h2, {
      id: "超龄入学",
      children: "超龄入学"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.5",
      children: _jsxs(_components.p, {
        children: ["我们尚未充分讨论这样一个事实：在许多国家，超过四分之一的小学生入学时已", _jsx(_components.strong, {
          children: "超龄"
        }), "，这意味着他们的年龄要比同年级学生应有的年龄大得多。这对他们的未来有着重大影响，增加了他们留级、考试不及格和最终辍学的可能性。"]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["这张图表展示了", _jsx(_components.strong, {
        children: "入学"
      }), "情况，显示了儿童、青少年和青年在接受学前、小学、初中和高中以及中学后教育时的年龄。颜色的分布表示在各自教育阶段，超龄儿童的比例。灰色阴影区域显示的是按年龄分列的失学儿童和青少年的百分比。"]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "OVERAGE"
        })
      }), _jsx(ScrollySection, {
        id: "KHM",
        children: _jsxs(_components.p, {
          children: ["在", _jsx(Highlight, {
            children: "柬埔寨"
          }), "，大多数 10\n岁的儿童应该在学校接受教育，但仍有 21％ 的儿童在这一年龄还未能入学。许多儿童远超\n他们所在年级的年龄水平。例如，有些 14 岁的孩子还在上小学\n。"]
        })
      }), _jsx(ScrollySection, {
        id: "LBR",
        children: _jsxs(_components.p, {
          children: ["有些国家的超龄现象更为严重，例如", " ", "\n", _jsx(Highlight, {
            children: "利比里亚"
          }), "，10 岁儿童中有 28% 还在接受学前教育，而\n18 岁孩子中有 20% 仍在上小学。"]
        })
      }), _jsx(ScrollySection, {
        id: "NPL",
        children: _jsxs(_components.p, {
          children: [_jsx(Highlight, {
            children: "尼泊尔"
          }), "面临着同样的挑战，"]
        })
      }), _jsx(ScrollySection, {
        id: "MWI",
        children: _jsxs(_components.p, {
          children: ["而", _jsx(Highlight, {
            children: "马拉维"
          }), "亦是如此。"]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "失学儿童",
      children: "失学儿童"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.4",
      children: [_jsxs(_components.p, {
        children: ["全球有 2.72 亿", _jsx(_components.strong, {
          children: "失学"
        }), "儿童和青年。"]
      }), _jsx(_components.p, {
        children: "冲突是导致这一数字停滞不前的关键原因。遗憾的是，尽管一些国家仍在继续提供估算数据，但冲突也意味着数据的可用性和质量下降。为了准确评估新冠疫情对入学率的近期影响，还需要更多长期持续的信息。"
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "OOSRATE"
          })
        }), _jsx(ScrollySection, {
          id: "ECU,PRY",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "厄瓜多尔"
            }), "和", _jsx(Highlight, {
              children: "巴拉圭"
            }), "呈现出\n截然不同的教育进步趋势。在初中和高中教育中，\n厄瓜多尔的失学率直线下降，而\n巴拉圭的失学率却在攀升。"]
          })
        }), _jsx(ScrollySection, {
          id: "ERI,ETH",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "厄立特里亚"
            }), "和", _jsx(Highlight, {
              children: "埃塞俄比亚"
            }), "在\n教育进展上也表现出极大差异。在厄立特里亚，冲突的后遗症\n明显影响了教育的可及性，而埃塞俄比亚则将\n教育纳入其预算中的优先事项，从而在短时间内迅速减少了\n失学儿童的数量。"]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "另一个导致减少失学人数进展缓慢的原因是人口增长。"
    }), "\n", _jsxs(_components.p, {
      children: ["在撒哈拉以南非洲地区，小学", _jsx(HighlightByIndex, {
        index: "2",
        children: "学龄人口"
      }), "在 2000 年至 2023 年间几乎翻了一番。因此，尽管在此期间", _jsx(HighlightByIndex, {
        index: "0",
        children: "失学儿童比例"
      }), "近乎减半，但", _jsx(HighlightByIndex, {
        index: "1",
        children: "失学儿童人数"
      }), "几乎没有变化。"]
    }), "\n", _jsx(Figure, {
      id: "OOSREL"
    }), "\n", _jsx(_components.p, {
      children: "完成率"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.2",
      children: [_jsxs(_components.p, {
        children: ["SDG 4 的最终目标是普遍实现高中教育", _jsx(_components.strong, {
          children: "完成率"
        }), "，而不仅仅是入学率。尽管如此，在许多国家，免费的义务教育最多只覆盖到初中阶段。"]
      }), _jsx(_components.p, {
        children: "全球甚至无法在截止日期前实现普遍完成小学教育，更不用说高中教育完成率了。按照目前的趋势，到 2030 年，只有大约十分之六的年轻人能完成中学教育。"
      }), _jsxs(_components.p, {
        children: ["该指标指的是可能比官方毕业年龄晚 3 或 5 年完成各教育阶段的儿童——这可以定义为", _jsx(Tooltip, {
          title: "按时完成",
          content: "在最后一年级后 3 到 5 年内完成教育阶段的儿童",
          children: "按时完成"
        }), "。但是许多儿童完成学业的时间甚至比这更晚——这可以定义为", _jsx(Tooltip, {
          title: "最终完成",
          content: "在最后一年级后 8 年内完成教育阶段的儿童",
          children: "最终完成"
        }), "。"]
      }), _jsxs(_components.p, {
        children: ["从下图来看，以莫桑比克为例，在小学阶段，", _jsx(HighlightByIndex, {
          index: "0",
          children: "及时"
        }), "完成 (49%) 与", _jsx(HighlightByIndex, {
          index: "1",
          children: "最终"
        }), "完成 (66%) 学业的比例之间存在近 20 个百分点的差距。"]
      }), _jsx(Figure, {
        id: "COMPLETION"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "结语",
      children: "结语"
    }), "\n", _jsx(_components.p, {
      children: "儿童的入学和毕业年龄以及他们能否顺利毕业是关键的政策问题。"
    }), "\n", _jsxs(_components.p, {
      children: ["本网站接下来的主题将探讨我们距离实现", _jsx(PageLink, {
        name: "equity",
        children: "平等"
      }), "教育有多远、学生", _jsx(PageLink, {
        name: "learning",
        children: "所学"
      }), "内容、教育", _jsx(PageLink, {
        name: "quality",
        children: "质量"
      }), "如何，以及谁在为教育提供", _jsx(PageLink, {
        name: "finance",
        children: "财政"
      }), "支撑。"]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-estimates.org",
            children: "世界教育指标可视化 (VIEW)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000382577",
            children: "新的估算证据证实撒哈拉以南非洲地区的失学人口正在增长"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://resourcecentre.savethechildren.net/library/education-against-odds-meeting-marginalised-childrens-demands-quality-education",
            children: "逆境中的教育 — 救助儿童会"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "整合失学儿童、学业完成和学习情况数据，以更加全面地了解 SDG 4"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
